<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
    <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title>
        <h3>{{ get_dialogMain.title }}</h3>
      </v-toolbar-title>
      <v-spacer/>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <MainGeneralForm :form="fields" :model="form" :on-success="save" :on-cancel="cancel" />
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
export default {
  props: ['fields', 'model', 'urls', 'message'],
  data: () => ({
    form: {}
  }),
  components: {
    MainGeneralForm
  },
  mounted () {
    this.form = Object.assign({}, this.model)
  },
  methods: {
    ...mapActions(['PostObject', 'PutObject']),
    save (model) {
      if (model.id) {
        this.PutObject({ url: this.urls, data: model })
      } else {
        this.PostObject({ url: this.urls, data: model })
      }
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA', 'SET_DATA', 'SET_RELOAD_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: this.message
      })

      if (this.get_dialogMain.body.reload) {
        this.SET_RELOAD_DATA({ name: this.get_dialogMain.type, data: val })
      } else {
        this.SET_DATA(val)
      }
      // this.CLEAR_DATA()
      this.cancel()
    }
  }
}
</script>

<style>
</style>
